import {
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import { useLocation } from "react-router-dom";

const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!STRIPE_PUBLIC_KEY) {
  throw new Error("Missing STRIPE_PUBLIC_KEY in environment variables");
}

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const StripePaymentScreen = () => {
  const location = useLocation();
  const secret = location?.state?.clientSecret;

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: secret,
        appearance: { theme: "stripe" },
      }}
    >
      <CheckoutForm />
    </Elements>
  );
};

export default StripePaymentScreen;